import { render, staticRenderFns } from "./LessonChatHistoryViewerComponent.vue?vue&type=template&id=64d73b20&scoped=true&"
import script from "./LessonChatHistoryViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonChatHistoryViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonChatHistoryViewerComponent.vue?vue&type=style&index=0&id=64d73b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d73b20",
  null
  
)

export default component.exports